module.exports = __webpack_public_path__ + "img/map.63829112.png";